import { isTrue, optional, required } from '@bw/core';

export const config = {
	...optional('gtmId', process.env.GOOGLE_TAG_MANAGER_ID),
	...optional('recaptchaSecret', process.env.RECAPTCHA_SECRET_KEY),
	...optional('legacyApiBase', process.env.LEGACY_API, 'https://brightway-dev.azurewebsites.net/'),
	...optional('bwApiUrl', process.env.BW_API_URL),
	...optional('bwApiSubscriptionKey', process.env.BW_API_SUBSCRIPTION_KEY),
	...optional('bwSecurityToken', process.env.BW_SECURITY_TOKEN),
	...optional('revalidationSecret', process.env.REVALIDATION_SECRET),
	...required('domainUrl', process.env.DOMAIN_URL),
	...optional('customerPortalUrl', process.env.NEXT_PUBLIC_CUSTOMER_PORTAL_URL, 'https://customer.brightway.com/policies/'),
	...isTrue('previewEnabled', process.env.PREVIEW_ENABLED),
	...optional('nodeEnv', process.env.NODE_ENV),
	...required('sendGridApiKey', process.env.SENDGRID_API_KEY),

	// Producer Placement form
	...optional('producerPlacementRecipients', process.env.PRODUCER_PLACEMENT_FORM_SUBMISSION_RECIPIENTS),
	// Storage app – blob upload/scan
	...optional('azureStorageTenantId', process.env.AZURE_STORAGE_TENANT_ID),
	...optional('azureStorageClientId', process.env.AZURE_STORAGE_CLIENT_ID),
	...optional('azureStorageClientSecret', process.env.AZURE_STORAGE_CLIENT_SECRET),
	...optional('uploadLandingAccount', process.env.AZURE_UPLOAD_LANDING_ACCOUNT, 'bwue1tfcuploadland'),
	...optional('uploadCleanAccount', process.env.AZURE_UPLOAD_CLEAN_ACCOUNT, 'bwue1tfcuploadclean'),
	...optional('uploadScanContainer', process.env.AZURE_UPLOAD_SCAN_CONTAINER, 'web-apps-brightway-com'),
	// Graph app – SharePoint upload
	...optional('azureGraphTenantId', process.env.AZURE_GRAPH_TENANT_ID),
	...optional('azureGraphClientId', process.env.AZURE_GRAPH_CLIENT_ID),
	...optional('azureGraphClientSecret', process.env.AZURE_GRAPH_CLIENT_SECRET),
	...optional('sharepointSiteId', process.env.SHAREPOINT_SITE_ID),
	...optional('sharepointDriveId', process.env.SHAREPOINT_DRIVE_ID),
	...optional('sharepointFolderPath', process.env.SHAREPOINT_FOLDER_PATH),

	contentful: {
		...required('version', process.env.CONTENTFUL_VERSION),
		...required('spaceId', process.env.CONTENTFUL_SPACE_ID),
		...required('envId', process.env.CONTENTFUL_ENVIRONMENT),
		...required('accessToken', process.env.CONTENTFUL_ACCESS_TOKEN),
	},

	csp: {
		...isTrue('disabled', process.env.DISABLE_CSP),
		...optional('connectSafeList', process.env.CSP_CONNECT_SAFELIST),
		...optional('fontSafeList', process.env.CSP_FONT_SAFELIST),
		...optional('frameSafeList', process.env.CSP_FRAME_SAFELIST),
		...optional('frameAncestorsSafeList', process.env.CSP_FRAME_ANCESTORS_SAFELIST),
		...optional('imgSafeList', process.env.CSP_IMG_SAFELIST),
		...optional('mediaSafeList', process.env.CSP_MEDIA_SAFELIST),
		...optional('scriptSafeList', process.env.CSP_SCRIPT_SAFELIST),
		...optional('styleSafeList', process.env.CSP_STYLE_SAFELIST),
	},
} as const;

export const publicConfig = {
	...optional('appInsightsKey', process.env.NEXT_PUBLIC_APPINSIGHTS_KEY),
	...optional('googleMapsApiKey', process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY),
	...optional('recaptchaSiteKey', process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY),
	...optional('customerIntakeURL', process.env.NEXT_PUBLIC_CUSTOMER_INTAKE_URL, 'https://intake.brightway.com'),
} as const;
